var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainFunctions',{attrs:{"buttons":_vm.buttons,"title":_vm.$t('menu.nav-storehome-title')}})}
var staticRenderFns = []

export { render, staticRenderFns }